import '.ac{position:relative;}.ssr-plugin'
import '.be{position:absolute;}.ssr-plugin'
import '.dl{font-size:0.75rem;}.ssr-plugin'
import '.dm{line-height:normal;}.ssr-plugin'
import '.dn{top:-0.25rem;}.ssr-plugin'
import '.do{right:-0.5rem;}.ssr-plugin'
import '.dp{background-color:var(--gray-100);}.ssr-plugin'
import '.dq{border-radius:0.35rem;}.ssr-plugin'
import '.dr{width:0.75rem;}.ssr-plugin'
import '.ds{height:0.75rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ai{justify-content:center;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  faPaperclip,
  type IconDefinition,
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useRef, ChangeEvent } from 'react'
import { Text } from '@app/components/core/typography/Text'

export type FileSelectorProps = {
  icon?: IconDefinition
  label?: string
  filesSelected?: number
  maxFiles?: number
  maxSizeMB?: number
  allowedFileTypes?: string[]
  iconStyle?: Style
  labelStyle?: Style
  containerStyle?: Style
  onFileSelectionUpdated: (files: File[]) => void
  onDisallowedFileTypeSelected?: () => void
  disabled?: boolean
}

export const FileSelector = ({
  icon,
  label,
  filesSelected = 0,
  maxFiles = 1,
  maxSizeMB = 5,
  allowedFileTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg'],
  iconStyle,
  labelStyle,
  containerStyle,
  onFileSelectionUpdated,
  onDisallowedFileTypeSelected,
  disabled = false,
}: FileSelectorProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const onFileUploadClicked = () => {
    if (!disabled) {
      fileInputRef.current?.click()
    }
  }
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files: File[] = []
    let hasDisallowedFileType = false
    const maxSizeBytes = maxSizeMB * 1024 * 1024
    for (const file of event.target.files ?? []) {
      if (files.length === maxFiles) {
        break
      }
      if (!allowedFileTypes.includes(file.type)) {
        hasDisallowedFileType = true
        continue
      }
      if (file.size > maxSizeBytes) {
        continue
      }
      files.push(file)
    }
    if (hasDisallowedFileType) {
      onDisallowedFileTypeSelected?.()
    }
    onFileSelectionUpdated(files)
  }

  return (
    <>
      <styled.div className="ac"
        onClick={onFileUploadClicked}
        style={{
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
          ...(label
            ? {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '0.5rem',
              }
            : {}),
          ...containerStyle,
        }}
      >
        <FontAwesomeIcon icon={icon ?? faPaperclip} style={iconStyle} />
        {label ? (
          <Text.Medium
            style={{
              textAlign: 'center',
              ...labelStyle,
            }}
          >
            {label}
          </Text.Medium>
        ) : null}
        {filesSelected > 0 && (
          <span className="be dl dm dn do dp dq dr ds d t ai"
          >
            {filesSelected}
          </span>
        )}
      </styled.div>

      <input
        type="file"
        accept={allowedFileTypes.join(',')}
        multiple={maxFiles > 1}
        ref={fileInputRef}
        onChange={handleFileChange}
        disabled={disabled}
        style={{ display: 'none' }}
      />
    </>
  )
}
